import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { sanitizeHTML } from '../../helpers/utils'

const Legal = styled.div(({ style }) => {
  return {
    fontFamily: 'var(--headingFont)',
    fontSize: '10px',
    fontWeight: 'bold',
    lineHeight: '18px',
    letterSpacing: '0.25px',
    textAlign: 'left',
    p: { margin: '0' },
    '@media (max-width: 767px)': { paddingTop: '60px' },
    ...style
  }
})

const vStyle = {
  v2: { padding: '80px 40px 0px 0px' },
  v3: { padding: '80px 40px 0px 0px' },
  v4: {
    padding: '50px 0 0',
    color: 'var(--grey-1)',
    fontWeight: 'normal'
  }
}

const FooterLegal = ({ text, version, ...rest }) => {
  return (
    <div className="row one-column">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <Legal
          style={vStyle[version]}
          {...rest}
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(text)
          }}
        />
      </div>
    </div>
  )
}

FooterLegal.propTypes = {
  text: PropTypes.string.isRequired,
  version: PropTypes.string
}

export default FooterLegal



// WEBPACK FOOTER //
// ./src/components/Footer/FooterLegal.js